export const normalizeFocusAskLinkUrl = (url: string): string | null => {
	let normalizedUrl = url.trim();

	if (!normalizedUrl) {
		return null;
	}

	if (!normalizedUrl.includes('://')) {
		normalizedUrl = `http://${normalizedUrl}`;
	}

	try {
		return new URL(normalizedUrl).href;
	} catch {
		return null;
	}
};

export const isAllowedFocusAskLinkUrl = (url: string): boolean =>
	Boolean(normalizeFocusAskLinkUrl(url));
